import { withOpacity as r } from "./index.es60.js";
var e = {
  backgroundDark: "#595f76",
  gray1: "#FFFFFF",
  gray2: "#FAFAFA",
  gray3: "#EFEFF1",
  gray4: "#E4E4E7",
  gray5: "#D6D6D8",
  gray6: "#AEAEB7",
  gray7: "#838391",
  gray8: "#60606C",
  gray9: "#3A3A41",
  gray10: "#222226",
  pearl1: "#F8FAFB",
  pearl2: "#F2F5F8",
  pearl3: "#EBEFF4",
  pearl4: "#DEE5ED",
  pearl5: "#BDCBDB",
  pearl6: "#9CB1C9",
  pearl7: "#6788AC",
  pearl8: "#455F7D",
  pearl9: "#202D3B",
  pearl10: "#19232E",
  blue1: "#EFF4FD",
  blue2: "#DEEBFF",
  blue3: "#C2D6F6",
  blue4: "#A6C2F1",
  blue5: "#76A2EA",
  blue6: "#3C7BE1",
  blue7: "#2D5CA9",
  blue8: "#244883",
  blue9: "#1B3664",
  blue10: "#122543",
  purple1: "#F7F0FF",
  purple2: "#EBD6FF",
  purple3: "#DCB8FF",
  purple4: "#C78FFF",
  purple5: "#B56AFF",
  purple6: "#A346FF",
  purple7: "#8D1EFA",
  purple8: "#7619D2",
  purple9: "#5C14A4",
  purple10: "#470F80",
  pink1: "#FFF5F9",
  pink2: "#FFD6E6",
  pink3: "#FFB1CF",
  pink4: "#FE8DBA",
  pink5: "#FE609E",
  pink6: "#FA2075",
  pink7: "#D51B64",
  pink8: "#B41755",
  pink9: "#7F103C",
  pink10: "#640D2F",
  red1: "#FFF0F0",
  red2: "#FFC2C2",
  red3: "#FF9999",
  red4: "#FF7A7A",
  red5: "#FF4747",
  red6: "#EB3232",
  red7: "#C10000",
  red8: "#970000",
  red9: "#760000",
  red10: "#530000",
  orange1: "#FFF6EB",
  orange2: "#FFE5C2",
  orange3: "#FFDDAD",
  orange4: "#FFC166",
  orange5: "#FFA029",
  orange6: "#E06600",
  orange7: "#AD4E00",
  orange8: "#8F4000",
  orange9: "#5C2900",
  orange10: "#3E1C00",
  yellow1: "#FFFBEB",
  yellow2: "#FEF4C3",
  yellow3: "#FCE77D",
  yellow4: "#FFD429",
  yellow5: "#F5BC00",
  yellow6: "#D69C00",
  yellow7: "#A37700",
  yellow8: "#7A5A00",
  yellow9: "#483400",
  yellow10: "#302300",
  green1: "#F1F9F1",
  green2: "#D4ECD4",
  green3: "#B0DEB0",
  green4: "#95D195",
  green5: "#7FC77F",
  green6: "#54A054",
  green7: "#428042",
  green8: "#356435",
  green9: "#203E20",
  green10: "#162916"
},
    a = {
  0: "#e76b5a",
  1: "#e69b5b",
  2: "#e7d15a",
  3: "#a0d176",
  4: "#7ec191",
  5: "#6cb5c0",
  6: "#668bb5",
  7: "#816dbf",
  8: "#bf6d9d",
  9: "#3d7980",
  10: "#305177",
  11: "#813d47"
},
    n = {
  brandGradient: "linear-gradient(to right, #FF2F80, #CEA5FF, #438CFF)",
  BGbrandGradient: "linear-gradient(to right, #050A1C, #1C274B, #282148, #1A1326, #060917)"
},
    l = {
  start: "#6EA36E",
  playAudio: "#A26FD3",
  dtmf: "#B06291",
  voicemail: "#E7932C",
  sendMessage: "#6A7FCA",
  condition: "#6CACB0",
  route: e.pearl7,
  httpRequest: e.pearl8,
  end: e.gray7
},
    t = {
  online: "#5bb85b",
  inCall: "#bc78ff",
  offline: "#acadc6",
  away: "#fb4145",
  ringing: "#ddbaff",
  postcall: "#78bfff",
  hold: "#bc78ff",
  transferFromRinging: "#bc78ff",
  transferFromTalk: "#bc78ff",
  transferToRinging: "#5bb85b",
  transferToTalk: "#5bb85b",
  intOutRinging: "#5bb85b",
  intOutTalk: "#5bb85b",
  intInRinging: "#5bb85b",
  intInTalk: "#5bb85b",
  extRinging: "#ff9c0a",
  extTalk: "#ff9c0a",
  dialing: e.orange4,
  dialerPending: "#ff9c0a",
  outbound: "#ff9c0a",
  dialer: "#ff9c0a",
  dialerTalk: "#ff9c0a",
  monitoring: "#ff9c0a",
  whispering: "#ff9c0a",
  bargingIn: "#ff9c0a"
},
    i = {
  facebook: "linear-gradient(0deg, #09f -22.73%, #a033ff 72.89%, #ff5280 123.87%, #ff7061 134.09%)",
  whatsApp: "#25d366",
  telegram: "#56b4f1",
  instagram: "radial-gradient(99.11% 99.11% at 26.56% 107.7%, #fd5 0%, #fd5 10%, #ff543e 50%, #c837ab 100%)",
  webChat: e.blue6,
  viber: "#7360f2",
  contact: e.gray3,
  agent: e.blue2,
  manager: e.yellow2,
  error: e.red1,
  inactiveChannel: "#9aa8b6"
},
    o = {
  unavailable: "#d3d3d3",
  empty: "#d3d3d3",
  answered: a[9],
  noAnswer: a[5],
  busy: a[2],
  rejected: a[1],
  failed: a[0],
  machineAnswered: "#92d3e0"
},
    g = {
  attempts0: "#ced0d3",
  attempts1: a[5],
  attempts2: a[3],
  attempts3: "#e8d159",
  attempts4: "#e79a5b",
  attempts5: a[0],
  attemptsEmpty: "#d3d3d3"
},
    d = {
  background: "#F6F8F9",
  blue015: r(e.blue6, 0.15),
  gray007: r(e.gray9, 0.07),
  gray015: r(e.gray10, 0.15),
  overlayCover: r(e.gray10, 0.4),
  white060: r(e.gray1, 0.6),
  divider: r(e.gray10, 0.1)
};
export { t as agentStatusPalette, g as attemptsColors, a as barColors, n as brandColors, o as callDispositionColors, i as digitalChannelsPalette, l as flowBuilderPalette, d as otherColors, e as palette, r as withOpacity };